module.exports = __webpack_public_path__ + "static/media/setting_inst.1a020b49.png";